import { Button, Flex, Text } from '@mantine/core';
import noAccessImage from '../../assets/images/cancel-inprogress-extraction.png';

export const NoAccess = ({ message = 'Your account is not authorized to access this page' }) => (
  <Flex id="no-access-container" justify="center" align="center" direction="column" gap="md">
    <img id="no-access-image" width={120} src={noAccessImage} alt="No Access" />
    <Text id="no-access-message">{message}</Text>
    <Button id="no-access-go-home-button" component="a" href="/project">
      Go to home
    </Button>
  </Flex>
);
